import { authApi } from "@/main/api";
import { getPreviousRoute, saveStringStorage, STORAGE_REFRESH_TOKEN, STORAGE_TOKEN } from "@/main/services/storage";
import { isNullUndefined, removeParamsFromURL } from "@/main/services/utils";
import { store } from "@/main/store";
import { userSetCurrent, userOpenModalUserChangePasswordAlert } from "@/main/store/user";
import { PropsWithChildren, useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { BlockPage, RootLayout } from "./style";
import { useCheckVersion } from "@/main/hooks/useCheckVersion";

function LayoutApp({ children }: PropsWithChildren) {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const [isLoadingSSO, setLoadingSSO] = useState(false);

	useCheckVersion();

	useEffect(() => {
		getSSOToken();
	}, [searchParams]);
	function getSSOToken() {
		const KEY_SSO_TOKEN = "sso_token";
		const ValueSSOToken = searchParams.get(KEY_SSO_TOKEN);
		if (isNullUndefined(ValueSSOToken)) return;
		setLoadingSSO(true);
		authApi
			.loginApi({ grant_type: KEY_SSO_TOKEN, token: ValueSSOToken })
			.then((response) => {
				const { result } = response.data;
				const PREVIOUS_ROUTE_STORAGE = getPreviousRoute();
				const redirectRoute = PREVIOUS_ROUTE_STORAGE !== "" ? PREVIOUS_ROUTE_STORAGE : result.redirectRoute;
				store.dispatch(userSetCurrent(result));
				saveStringStorage(STORAGE_TOKEN, result.token);
				saveStringStorage(STORAGE_REFRESH_TOKEN, result.refreshToken);
				const formatRedirectRoute = removeParamsFromURL(redirectRoute, KEY_SSO_TOKEN);

				navigate(formatRedirectRoute);

				if (
					!isNullUndefined(result.vizualizeModal) &&
					result.vizualizeModal &&
					!isNullUndefined(result.numberOfDaysToPasswordExpires)
				) {
					store.dispatch(userOpenModalUserChangePasswordAlert(true, result.numberOfDaysToPasswordExpires));
				}
			})
			.catch(() => {})
			.finally(() => {
				setLoadingSSO(false);
			});
	}

	return (
		<RootLayout>
			{children}
			{isLoadingSSO && <BlockPage></BlockPage>}
		</RootLayout>
	);
}

export default LayoutApp;
